/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CampaignMemberDetailDto } from '../models';
// @ts-ignore
import type { CampaignMemberPlanStatusDto } from '../models';
// @ts-ignore
import type { DevelopmentCycleCampaignCancelResultDto } from '../models';
// @ts-ignore
import type { DevelopmentCycleCampaignDto } from '../models';
// @ts-ignore
import type { DevelopmentCycleCampaignMembersPageDto } from '../models';
// @ts-ignore
import type { DevelopmentCycleTaskSweepResultDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SaveDevelopmentCycleCampaignDto } from '../models';
/**
 * DevelopmentCycleCampaignsApi - axios parameter creator
 * @export
 */
export const DevelopmentCycleCampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Kończy kampanię: dezaktywuje ją i przenosi WSZYSTKIE jej plany rozwojowe (łącznie ze zrealizowanymi) do historycznych, anulując ich otwarte zadania. Świadomie osobna akcja, a nie przełącznik „aktywna\" — archiwizacja planów setek osób nie może odpalić przypadkiem. Plan historyczny da się przywrócić, gdy pracownika znów obejmuje ta kampania.
         * @summary Cancel a campaign and archive its development plans
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDevelopmentCycleCampaign: async (campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('cancelDevelopmentCycleCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}/cancel`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tworzy kampanię. Aktywnych kampanii może być kilka równolegle, ale numer SAP może należeć tylko do jednej z nich, a kampania ogólna („obejmij wszystkich\") może być tylko jedna — 409 przy naruszeniu.
         * @summary Create a development-cycle campaign
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevelopmentCycleCampaign: async (saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveDevelopmentCycleCampaignDto' is not null or undefined
            assertParamExists('createDevelopmentCycleCampaign', 'saveDevelopmentCycleCampaignDto', saveDevelopmentCycleCampaignDto)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDevelopmentCycleCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevelopmentCycleCampaign: async (campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('deleteDevelopmentCycleCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaign: async (campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getDevelopmentCycleCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wszystko o jednym pracowniku objętym kampanią, do testowania i podglądu: nagłówek jak na liście, jego plany (wszystkie realne cykle, każdy z campaignId — widać i zarchiwizowane z innej kampanii), oraz KOMPLET zadań związanych z planami: pre-planowe i review (celują w pracownika) oraz krokowe (celują w ścieżki kompetencji), otwarte i zamknięte.
         * @summary Full drill-down for one covered employee
         * @param {number} campaignId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaignMemberDetail: async (campaignId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getDevelopmentCycleCampaignMemberDetail', 'campaignId', campaignId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getDevelopmentCycleCampaignMemberDetail', 'employeeId', employeeId)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}/members/{employeeId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca stronicowaną listę pracowników objętych kampanią — dla kampanii zadaniowej z jej listy SAP, dla kampanii ogólnej wszystkich nieobjętych inną kampanią zadaniową. Dla każdego pokazuje status planu, otwarte zadanie oraz POWÓD braku zadania (kampania ogólna / przed startem zadań / brak konta / plan już istnieje / czeka na skan). Liczona tą samą regułą co silnik zadań.
         * @summary List the employees a campaign covers
         * @param {number} campaignId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchPhrase] Filtr po imieniu, nazwisku lub numerze SAP (częściowy, case-insensitive).
         * @param {CampaignMemberPlanStatusDto} [planStatus] Filtr po statusie planu w tej kampanii (NONE &#x3D; brak planu).
         * @param {boolean} [withoutUserAccount] Tylko pracownicy bez konta użytkownika (dla nich nie powstają zadania).
         * @param {boolean} [withoutTask] Tylko pracownicy bez otwartego zadania pre-planowego.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaignMembers: async (campaignId: number, page?: number, pageSize?: number, searchPhrase?: string, planStatus?: CampaignMemberPlanStatusDto, withoutUserAccount?: boolean, withoutTask?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getDevelopmentCycleCampaignMembers', 'campaignId', campaignId)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}/members`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (planStatus !== undefined) {
                localVarQueryParameter['planStatus'] = planStatus;
            }

            if (withoutUserAccount !== undefined) {
                localVarQueryParameter['withoutUserAccount'] = withoutUserAccount;
            }

            if (withoutTask !== undefined) {
                localVarQueryParameter['withoutTask'] = withoutTask;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca wszystkie skonfigurowane kampanie cyklu rozwojowego (panel admina).
         * @summary List development-cycle campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaigns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/development-cycle-campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Narzędzie testowe: odpala od ręki to, co dobowy scheduler 06:15 — przy aktywnej kampanii tworzy zadania inicjalizacji/utworzenia planu (z dedupem), bez aktywnej sprząta zalegające. Zwraca liczniki.
         * @summary Run the plan-initiation task sweep on demand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDevelopmentCycleTaskSweep: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/task-sweep`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a development-cycle campaign
         * @param {number} campaignId 
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCycleCampaign: async (campaignId: number, saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateDevelopmentCycleCampaign', 'campaignId', campaignId)
            // verify required parameter 'saveDevelopmentCycleCampaignDto' is not null or undefined
            assertParamExists('updateDevelopmentCycleCampaign', 'saveDevelopmentCycleCampaignDto', saveDevelopmentCycleCampaignDto)
            const localVarPath = `/api/v2/admin/development-cycle-campaigns/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDevelopmentCycleCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentCycleCampaignsApi - functional programming interface
 * @export
 */
export const DevelopmentCycleCampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentCycleCampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Kończy kampanię: dezaktywuje ją i przenosi WSZYSTKIE jej plany rozwojowe (łącznie ze zrealizowanymi) do historycznych, anulując ich otwarte zadania. Świadomie osobna akcja, a nie przełącznik „aktywna\" — archiwizacja planów setek osób nie może odpalić przypadkiem. Plan historyczny da się przywrócić, gdy pracownika znów obejmuje ta kampania.
         * @summary Cancel a campaign and archive its development plans
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleCampaignCancelResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDevelopmentCycleCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.cancelDevelopmentCycleCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tworzy kampanię. Aktywnych kampanii może być kilka równolegle, ale numer SAP może należeć tylko do jednej z nich, a kampania ogólna („obejmij wszystkich\") może być tylko jedna — 409 przy naruszeniu.
         * @summary Create a development-cycle campaign
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.createDevelopmentCycleCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDevelopmentCycleCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.deleteDevelopmentCycleCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCycleCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.getDevelopmentCycleCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wszystko o jednym pracowniku objętym kampanią, do testowania i podglądu: nagłówek jak na liście, jego plany (wszystkie realne cykle, każdy z campaignId — widać i zarchiwizowane z innej kampanii), oraz KOMPLET zadań związanych z planami: pre-planowe i review (celują w pracownika) oraz krokowe (celują w ścieżki kompetencji), otwarte i zamknięte.
         * @summary Full drill-down for one covered employee
         * @param {number} campaignId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCycleCampaignMemberDetail(campaignId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignMemberDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCycleCampaignMemberDetail(campaignId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.getDevelopmentCycleCampaignMemberDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca stronicowaną listę pracowników objętych kampanią — dla kampanii zadaniowej z jej listy SAP, dla kampanii ogólnej wszystkich nieobjętych inną kampanią zadaniową. Dla każdego pokazuje status planu, otwarte zadanie oraz POWÓD braku zadania (kampania ogólna / przed startem zadań / brak konta / plan już istnieje / czeka na skan). Liczona tą samą regułą co silnik zadań.
         * @summary List the employees a campaign covers
         * @param {number} campaignId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchPhrase] Filtr po imieniu, nazwisku lub numerze SAP (częściowy, case-insensitive).
         * @param {CampaignMemberPlanStatusDto} [planStatus] Filtr po statusie planu w tej kampanii (NONE &#x3D; brak planu).
         * @param {boolean} [withoutUserAccount] Tylko pracownicy bez konta użytkownika (dla nich nie powstają zadania).
         * @param {boolean} [withoutTask] Tylko pracownicy bez otwartego zadania pre-planowego.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCycleCampaignMembers(campaignId: number, page?: number, pageSize?: number, searchPhrase?: string, planStatus?: CampaignMemberPlanStatusDto, withoutUserAccount?: boolean, withoutTask?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleCampaignMembersPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCycleCampaignMembers(campaignId, page, pageSize, searchPhrase, planStatus, withoutUserAccount, withoutTask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.getDevelopmentCycleCampaignMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca wszystkie skonfigurowane kampanie cyklu rozwojowego (panel admina).
         * @summary List development-cycle campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCycleCampaigns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DevelopmentCycleCampaignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCycleCampaigns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.getDevelopmentCycleCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Narzędzie testowe: odpala od ręki to, co dobowy scheduler 06:15 — przy aktywnej kampanii tworzy zadania inicjalizacji/utworzenia planu (z dedupem), bez aktywnej sprząta zalegające. Zwraca liczniki.
         * @summary Run the plan-initiation task sweep on demand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runDevelopmentCycleTaskSweep(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleTaskSweepResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runDevelopmentCycleTaskSweep(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.runDevelopmentCycleTaskSweep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a development-cycle campaign
         * @param {number} campaignId 
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentCycleCampaign(campaignId: number, saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCycleCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentCycleCampaign(campaignId, saveDevelopmentCycleCampaignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCycleCampaignsApi.updateDevelopmentCycleCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentCycleCampaignsApi - factory interface
 * @export
 */
export const DevelopmentCycleCampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentCycleCampaignsApiFp(configuration)
    return {
        /**
         * Kończy kampanię: dezaktywuje ją i przenosi WSZYSTKIE jej plany rozwojowe (łącznie ze zrealizowanymi) do historycznych, anulując ich otwarte zadania. Świadomie osobna akcja, a nie przełącznik „aktywna\" — archiwizacja planów setek osób nie może odpalić przypadkiem. Plan historyczny da się przywrócić, gdy pracownika znów obejmuje ta kampania.
         * @summary Cancel a campaign and archive its development plans
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignCancelResultDto> {
            return localVarFp.cancelDevelopmentCycleCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Tworzy kampanię. Aktywnych kampanii może być kilka równolegle, ale numer SAP może należeć tylko do jednej z nich, a kampania ogólna („obejmij wszystkich\") może być tylko jedna — 409 przy naruszeniu.
         * @summary Create a development-cycle campaign
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto> {
            return localVarFp.createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDevelopmentCycleCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a development-cycle campaign
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto> {
            return localVarFp.getDevelopmentCycleCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wszystko o jednym pracowniku objętym kampanią, do testowania i podglądu: nagłówek jak na liście, jego plany (wszystkie realne cykle, każdy z campaignId — widać i zarchiwizowane z innej kampanii), oraz KOMPLET zadań związanych z planami: pre-planowe i review (celują w pracownika) oraz krokowe (celują w ścieżki kompetencji), otwarte i zamknięte.
         * @summary Full drill-down for one covered employee
         * @param {number} campaignId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaignMemberDetail(campaignId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignMemberDetailDto> {
            return localVarFp.getDevelopmentCycleCampaignMemberDetail(campaignId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca stronicowaną listę pracowników objętych kampanią — dla kampanii zadaniowej z jej listy SAP, dla kampanii ogólnej wszystkich nieobjętych inną kampanią zadaniową. Dla każdego pokazuje status planu, otwarte zadanie oraz POWÓD braku zadania (kampania ogólna / przed startem zadań / brak konta / plan już istnieje / czeka na skan). Liczona tą samą regułą co silnik zadań.
         * @summary List the employees a campaign covers
         * @param {number} campaignId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchPhrase] Filtr po imieniu, nazwisku lub numerze SAP (częściowy, case-insensitive).
         * @param {CampaignMemberPlanStatusDto} [planStatus] Filtr po statusie planu w tej kampanii (NONE &#x3D; brak planu).
         * @param {boolean} [withoutUserAccount] Tylko pracownicy bez konta użytkownika (dla nich nie powstają zadania).
         * @param {boolean} [withoutTask] Tylko pracownicy bez otwartego zadania pre-planowego.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaignMembers(campaignId: number, page?: number, pageSize?: number, searchPhrase?: string, planStatus?: CampaignMemberPlanStatusDto, withoutUserAccount?: boolean, withoutTask?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignMembersPageDto> {
            return localVarFp.getDevelopmentCycleCampaignMembers(campaignId, page, pageSize, searchPhrase, planStatus, withoutUserAccount, withoutTask, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca wszystkie skonfigurowane kampanie cyklu rozwojowego (panel admina).
         * @summary List development-cycle campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCycleCampaigns(options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentCycleCampaignDto>> {
            return localVarFp.getDevelopmentCycleCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * Narzędzie testowe: odpala od ręki to, co dobowy scheduler 06:15 — przy aktywnej kampanii tworzy zadania inicjalizacji/utworzenia planu (z dedupem), bez aktywnej sprząta zalegające. Zwraca liczniki.
         * @summary Run the plan-initiation task sweep on demand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDevelopmentCycleTaskSweep(options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleTaskSweepResultDto> {
            return localVarFp.runDevelopmentCycleTaskSweep(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a development-cycle campaign
         * @param {number} campaignId 
         * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCycleCampaign(campaignId: number, saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto> {
            return localVarFp.updateDevelopmentCycleCampaign(campaignId, saveDevelopmentCycleCampaignDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevelopmentCycleCampaignsApi - interface
 * @export
 * @interface DevelopmentCycleCampaignsApi
 */
export interface DevelopmentCycleCampaignsApiInterface {
    /**
     * Kończy kampanię: dezaktywuje ją i przenosi WSZYSTKIE jej plany rozwojowe (łącznie ze zrealizowanymi) do historycznych, anulując ich otwarte zadania. Świadomie osobna akcja, a nie przełącznik „aktywna\" — archiwizacja planów setek osób nie może odpalić przypadkiem. Plan historyczny da się przywrócić, gdy pracownika znów obejmuje ta kampania.
     * @summary Cancel a campaign and archive its development plans
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    cancelDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignCancelResultDto>;

    /**
     * Tworzy kampanię. Aktywnych kampanii może być kilka równolegle, ale numer SAP może należeć tylko do jednej z nich, a kampania ogólna („obejmij wszystkich\") może być tylko jedna — 409 przy naruszeniu.
     * @summary Create a development-cycle campaign
     * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto>;

    /**
     * 
     * @summary Delete a development-cycle campaign
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    deleteDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a development-cycle campaign
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    getDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto>;

    /**
     * Wszystko o jednym pracowniku objętym kampanią, do testowania i podglądu: nagłówek jak na liście, jego plany (wszystkie realne cykle, każdy z campaignId — widać i zarchiwizowane z innej kampanii), oraz KOMPLET zadań związanych z planami: pre-planowe i review (celują w pracownika) oraz krokowe (celują w ścieżki kompetencji), otwarte i zamknięte.
     * @summary Full drill-down for one covered employee
     * @param {number} campaignId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    getDevelopmentCycleCampaignMemberDetail(campaignId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignMemberDetailDto>;

    /**
     * Zwraca stronicowaną listę pracowników objętych kampanią — dla kampanii zadaniowej z jej listy SAP, dla kampanii ogólnej wszystkich nieobjętych inną kampanią zadaniową. Dla każdego pokazuje status planu, otwarte zadanie oraz POWÓD braku zadania (kampania ogólna / przed startem zadań / brak konta / plan już istnieje / czeka na skan). Liczona tą samą regułą co silnik zadań.
     * @summary List the employees a campaign covers
     * @param {number} campaignId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [searchPhrase] Filtr po imieniu, nazwisku lub numerze SAP (częściowy, case-insensitive).
     * @param {CampaignMemberPlanStatusDto} [planStatus] Filtr po statusie planu w tej kampanii (NONE &#x3D; brak planu).
     * @param {boolean} [withoutUserAccount] Tylko pracownicy bez konta użytkownika (dla nich nie powstają zadania).
     * @param {boolean} [withoutTask] Tylko pracownicy bez otwartego zadania pre-planowego.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    getDevelopmentCycleCampaignMembers(campaignId: number, page?: number, pageSize?: number, searchPhrase?: string, planStatus?: CampaignMemberPlanStatusDto, withoutUserAccount?: boolean, withoutTask?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignMembersPageDto>;

    /**
     * Zwraca wszystkie skonfigurowane kampanie cyklu rozwojowego (panel admina).
     * @summary List development-cycle campaigns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    getDevelopmentCycleCampaigns(options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentCycleCampaignDto>>;

    /**
     * Narzędzie testowe: odpala od ręki to, co dobowy scheduler 06:15 — przy aktywnej kampanii tworzy zadania inicjalizacji/utworzenia planu (z dedupem), bez aktywnej sprząta zalegające. Zwraca liczniki.
     * @summary Run the plan-initiation task sweep on demand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    runDevelopmentCycleTaskSweep(options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleTaskSweepResultDto>;

    /**
     * 
     * @summary Update a development-cycle campaign
     * @param {number} campaignId 
     * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApiInterface
     */
    updateDevelopmentCycleCampaign(campaignId: number, saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCycleCampaignDto>;

}

/**
 * DevelopmentCycleCampaignsApi - object-oriented interface
 * @export
 * @class DevelopmentCycleCampaignsApi
 * @extends {BaseAPI}
 */
export class DevelopmentCycleCampaignsApi extends BaseAPI implements DevelopmentCycleCampaignsApiInterface {
    /**
     * Kończy kampanię: dezaktywuje ją i przenosi WSZYSTKIE jej plany rozwojowe (łącznie ze zrealizowanymi) do historycznych, anulując ich otwarte zadania. Świadomie osobna akcja, a nie przełącznik „aktywna\" — archiwizacja planów setek osób nie może odpalić przypadkiem. Plan historyczny da się przywrócić, gdy pracownika znów obejmuje ta kampania.
     * @summary Cancel a campaign and archive its development plans
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public cancelDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).cancelDevelopmentCycleCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tworzy kampanię. Aktywnych kampanii może być kilka równolegle, ale numer SAP może należeć tylko do jednej z nich, a kampania ogólna („obejmij wszystkich\") może być tylko jedna — 409 przy naruszeniu.
     * @summary Create a development-cycle campaign
     * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).createDevelopmentCycleCampaign(saveDevelopmentCycleCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a development-cycle campaign
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public deleteDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).deleteDevelopmentCycleCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a development-cycle campaign
     * @param {number} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public getDevelopmentCycleCampaign(campaignId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).getDevelopmentCycleCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wszystko o jednym pracowniku objętym kampanią, do testowania i podglądu: nagłówek jak na liście, jego plany (wszystkie realne cykle, każdy z campaignId — widać i zarchiwizowane z innej kampanii), oraz KOMPLET zadań związanych z planami: pre-planowe i review (celują w pracownika) oraz krokowe (celują w ścieżki kompetencji), otwarte i zamknięte.
     * @summary Full drill-down for one covered employee
     * @param {number} campaignId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public getDevelopmentCycleCampaignMemberDetail(campaignId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).getDevelopmentCycleCampaignMemberDetail(campaignId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca stronicowaną listę pracowników objętych kampanią — dla kampanii zadaniowej z jej listy SAP, dla kampanii ogólnej wszystkich nieobjętych inną kampanią zadaniową. Dla każdego pokazuje status planu, otwarte zadanie oraz POWÓD braku zadania (kampania ogólna / przed startem zadań / brak konta / plan już istnieje / czeka na skan). Liczona tą samą regułą co silnik zadań.
     * @summary List the employees a campaign covers
     * @param {number} campaignId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [searchPhrase] Filtr po imieniu, nazwisku lub numerze SAP (częściowy, case-insensitive).
     * @param {CampaignMemberPlanStatusDto} [planStatus] Filtr po statusie planu w tej kampanii (NONE &#x3D; brak planu).
     * @param {boolean} [withoutUserAccount] Tylko pracownicy bez konta użytkownika (dla nich nie powstają zadania).
     * @param {boolean} [withoutTask] Tylko pracownicy bez otwartego zadania pre-planowego.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public getDevelopmentCycleCampaignMembers(campaignId: number, page?: number, pageSize?: number, searchPhrase?: string, planStatus?: CampaignMemberPlanStatusDto, withoutUserAccount?: boolean, withoutTask?: boolean, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).getDevelopmentCycleCampaignMembers(campaignId, page, pageSize, searchPhrase, planStatus, withoutUserAccount, withoutTask, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca wszystkie skonfigurowane kampanie cyklu rozwojowego (panel admina).
     * @summary List development-cycle campaigns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public getDevelopmentCycleCampaigns(options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).getDevelopmentCycleCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Narzędzie testowe: odpala od ręki to, co dobowy scheduler 06:15 — przy aktywnej kampanii tworzy zadania inicjalizacji/utworzenia planu (z dedupem), bez aktywnej sprząta zalegające. Zwraca liczniki.
     * @summary Run the plan-initiation task sweep on demand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public runDevelopmentCycleTaskSweep(options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).runDevelopmentCycleTaskSweep(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a development-cycle campaign
     * @param {number} campaignId 
     * @param {SaveDevelopmentCycleCampaignDto} saveDevelopmentCycleCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCycleCampaignsApi
     */
    public updateDevelopmentCycleCampaign(campaignId: number, saveDevelopmentCycleCampaignDto: SaveDevelopmentCycleCampaignDto, options?: RawAxiosRequestConfig) {
        return DevelopmentCycleCampaignsApiFp(this.configuration).updateDevelopmentCycleCampaign(campaignId, saveDevelopmentCycleCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }
}

